import http from 'helpers/APIHelper';
import { map } from 'rxjs/operators';

export const PACKET_ACTIONS = {
  GET_INDEXING: '@regulatory/packet/getIndexing',
  GET_NEXT_PACKET_ID: '@regulatory/packet/getNextPacketId',
  GET_PACKET_COMMUNICATION: '@regulatory/packet/getPacketCommunication',
  GET_TRACKINGCODE_STATUS: '@regulatory/packet/getTrackingCodeStatus',
  CLEAR_TRACKINGCODE_STATUS: '@regulatory/packet/clearTrackingCodeStatus',
  TOGGLE_ADDITIONAL_DETAILS_EDIT: '@regulatory/packet/toggleAdditionalDetailsEdit'
};

export const togglePacketLockBtn = (token, loggerInfo, postBody) => () => http
  .putWithToken(`regulatory-data-service/v1/packets/id/${postBody.id}`, token, JSON.stringify(postBody), loggerInfo)
  .pipe(map((resp) => resp));

export const toggleAdditionalDetails = (data) => (dispatch) => {
  dispatch({
    type: PACKET_ACTIONS.TOGGLE_ADDITIONAL_DETAILS_EDIT,
    payload: data
  });
};

const filterIndexingData = (data, type) => {
  if (data != null && data.length > 0) {
    switch (type) {
      case 'SITE_REGISTRATION':
      case 'INSTITUTION':
      case 'PAPER_CRFS_QUERIES':
      case 'MEMBERSHIP':
        return data.filter((row) => row.siteCtepId != null);
      case 'PERSON':
        return data.filter((row) => row.personCtepId != null);
      case 'ENROLLMENT_TRANSFERS':
        return data.filter((row) => row.patientId != null);
      default:
        return data;
    }
  }
  return [];
};

export const getIndexing = (token, loggerInfo, packetId, indexType, filter) => (dispatch) => {
  const postBody = {
    first: 0,
    isMetaRequired: true,
    size: -1,
    filter
  };
  const indexingHxrRequest = http.postWithToken(
    `regulatory-data-service/v1/packets/id/${packetId}/index/${indexType}`,
    token,
    postBody,
    loggerInfo
  );
  if (filter) {
    return indexingHxrRequest.pipe(map((resp) => resp.response));
  }
  return indexingHxrRequest.subscribe(
    (resp) => {
      dispatch({
        type: PACKET_ACTIONS.GET_INDEXING,
        payload: filterIndexingData(resp.response.data),
        attributeData: resp.response.meta.find((data) => data.name === 'objKeyValue').options
      });
    },
    (error) => {
      console.log('err: ', error);
    }
  );
};

export const setIndexing = (data = []) => (dispatch) => {
  dispatch({
    type: PACKET_ACTIONS.GET_INDEXING,
    payload: data
  });
};

export const updateIndexing = (token, loggerInfo, packetId, indexType, indexingRows) => () => http
  .putWithToken(
    `regulatory-data-service/v1/packets/id/${packetId}/index/${indexType}`,
    token,
    indexingRows,
    loggerInfo,
    'text'
  )
  .subscribe(
    (resp) => {
      console.log('response: ', resp);
    },
    (error) => {
      console.log('err: ', error);
    }
  );

export const deleteIndexing = (token, loggerInfo, packetId) => () => http
  .deleteWithToken(`regulatory-data-service/v1/packets/id/${packetId}/indices`, token, loggerInfo)
  .pipe(map((resp) => resp));

export const getNextPacketId = (token, loggerInfo, object, assignedTo) => () => http
  .getWithToken(
    `regulatory-data-service/v1/packets/object/${object}/assignedto/${assignedTo}/next`,
    token,
    loggerInfo,
    {},
    'text'
  )
  .pipe(map((resp) => resp.response));

export const createSR = (token, loggerInfo, packetId) => () => http
  .putWithToken(`regulatory-data-service/v1/packets/id/${packetId}/siterigistration`, token, null, loggerInfo, 'text')
  .pipe(map((resp) => resp.response));

export const getAutocompleteCtepIdApi = (token, loggerInfo, siteCtepIdLike, ognType = 'ALL') => () => http.getWithToken(`site-data-service/v1/sites/type/${ognType}/autocomplete/${siteCtepIdLike}`, token, loggerInfo);

export const getSupportDocs = (token, loggerInfo, packetId) => http
  .getWithToken(`regulatory-data-service/v1/packets/id/${packetId}/documents`, token, loggerInfo)
  .pipe(map((resp) => resp.response));

export const getProtocolAuoCompleteApi = (token, loggerInfo, protocolLike) => () => http.postWithToken(`protocol-data-service/v1/protocols/number/autocomplete`, token, protocolLike, loggerInfo);

export const copyPacket = (token, loggerInfo, packetId) => () => http
  .postWithToken(`regulatory-data-service/v1/packets/id/${packetId}/copy`, token, {}, loggerInfo, 'text')
  .pipe(map((resp) => resp.response));

export const getPersonAutoCompleteApi = (token, loggerInfo, personLike) => () => http.postWithToken(`person-data-service/v1/persons/autocomplete`, token, personLike, loggerInfo);

export const getPatientAutoCompleteApi = (token, loggerInfo, patientId) => () => http.getWithToken(`regulatory-data-service/v1/packets/number/${patientId}/patient/information`, token, loggerInfo);

export const saveIndexing = (token, loggerInfo, packetId, indexType, requestBody) => () => http
  .putWithToken(
    `regulatory-data-service/v1/packets/id/${packetId}/index/${indexType}`,
    token,
    requestBody,
    loggerInfo
  )
  .pipe(map((resp) => resp.response));

export const deleteIndexingRowApi = (token, loggerInfo, packetId, indexType) => () => http
  .deleteWithToken(`regulatory-data-service/v1/packets/id/${packetId}/index/${indexType}`, token, loggerInfo)
  .pipe(map((resp) => resp.response));

const getAdditionalDetailsFilter = (filter) => ({
  filter: [filter],
  isMetaRequired: false,
  sort: [
    {
      field: 'id',
      value: 'DESC'
    }
  ]
});

export const clearTrackingCodeStatus = () => (dispatch) => {
  dispatch({
    type: PACKET_ACTIONS.CLEAR_TRACKINGCODE_STATUS
  });
};

export const getTrackingCodeStatus = (token, loggerInfo, trackingBarCode) => (dispatch) => {
  const postBody = getAdditionalDetailsFilter({
    field: 'trackingBarCode',
    operation: 'contains',
    value: trackingBarCode
  });
  return http
    .postWithToken(`regulatory-data-service/v1/packets/browse`, token, JSON.stringify(postBody), loggerInfo)
    .subscribe(
      (resp) => {
        dispatch({
          type: PACKET_ACTIONS.GET_TRACKINGCODE_STATUS,
          payload: resp.response.data
        });
      },
      (error) => {
        console.log('err: ', error);
      }
    );
};

export const getPacketStatusHistory = (token, loggerInfo, pktId) => () => http.getWithToken(`regulatory-data-service/v1/packets/id/${pktId}/statushistory`, token, loggerInfo);

export const getPacketCommunication = (token, loggerInfo, packetId) => (dispatch) => http.getWithToken(`regulatory-data-service/v1/packets/id/${packetId}/comments`, token, loggerInfo).subscribe(
  (resp) => {
    dispatch({
      type: PACKET_ACTIONS.GET_PACKET_COMMUNICATION,
      payload: resp.response
    });
  },
  (error) => {
    console.log('err: ', error);
  }
);

export const getEmailPhoneDetails = (token, loggerInfo, ctsuid) => () => http.getWithToken(`person-data-service/v1/persons/id/${ctsuid}/personcontactdetails`, token, loggerInfo);

export const saveAdditionalDetails = (token, loggerInfo, packetId, postbody) => () => http
  .putWithToken(`regulatory-data-service/v1/packets/id/${packetId}`, token, postbody, loggerInfo)
  .pipe(map((resp) => resp.response));

export const getTrackingCodes = (token, loggerInfo, postdata) => () => http
  .postWithToken(`regulatory-data-service/v1/packets/browse`, token, postdata, loggerInfo)
  .pipe(map((resp) => resp.response));

export const saveComments = (token, loggerInfo, packetId, postBody) => () => http
  .postWithToken(`regulatory-data-service/v1/packets/id/${packetId}/comments`, token, postBody, loggerInfo)
  .pipe(map((resp) => resp.response));

export const generateProcess = (token, loggerInfo, pktId, indexType, errKey) => () => http
  .putWithToken(
    `regulatory-data-service/v1/packets/id/${pktId}/packetprocess/${indexType}`,
    token,
    null,
    loggerInfo,
    'text',
    errKey
  )
  .pipe(map((resp) => resp.response));

export const generateTrackingcode = (token, loggerInfo, id) => () => http
  .getWithToken(`regulatory-data-service/v1/packets/id/${id}/barcode`, token, loggerInfo, {}, 'text')
  .pipe(map((resp) => resp.response));

export const saveEventHistory = (token, loggerInfo, packetId, postBody) => () => http
  .postWithToken(`regulatory-data-service/v1/packets/id/${packetId}/statushistory`, token, postBody, loggerInfo)
  .pipe(map((resp) => resp.response));
